import { HomeOutput } from "@/interfaces/home";
import { BaseService, QueryParams } from "./BaseService";

export class HomeService extends BaseService<unknown, HomeOutput> {
  constructor() {
    super();
    this.path = "home";
  }

  async findOne(
    queryParams?: QueryParams,
    options?: RequestInit
  ): Promise<HomeOutput> {
    return (await this.request(this.path, {
      ...options,
      queryParams,
      method: "GET",
    })) as HomeOutput;
  }
}
